module.exports = __webpack_public_path__ + "officialStatic/img/pfx.405e37a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/pfx.png
// module id = z1QA
// module chunks = 0